(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],2:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],3:[function(require,module,exports){
"use strict";

require('./app/polyfills');

require('./app/started-functions');

require('./app/parallax');

require('./app/main-nav');

require('./app/mobile-menu');

require('./app/search');

require('./app/scroll');

require('./app/scroll-to-block');

require('./app/scrollspy');

require('./app/glide');

require('./app/tabs');

require('./app/modal');

require('./app/inputs');

require('./app/form');

require('./app/loadmore');

require('./app/accordion');

require('./app/tags-filter');

require('./app/glossary');

require('./app/cookie');

require('./app/foundation');

require('./app/lightbox');

},{"./app/accordion":4,"./app/cookie":5,"./app/form":6,"./app/foundation":7,"./app/glide":8,"./app/glossary":10,"./app/inputs":12,"./app/lightbox":13,"./app/loadmore":14,"./app/main-nav":15,"./app/mobile-menu":16,"./app/modal":17,"./app/parallax":18,"./app/polyfills":19,"./app/scroll":21,"./app/scroll-to-block":20,"./app/scrollspy":22,"./app/search":23,"./app/started-functions":24,"./app/tabs":25,"./app/tags-filter":26}],4:[function(require,module,exports){
"use strict";

var expandTogglers = document.querySelectorAll('[data-toggle="expand"]');

if (expandTogglers.length) {
  expandTogglers.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var target = item.getAttribute('data-target');
      var targetItem = document.getElementById('#' + target);
      item.parentElement.classList.toggle('active');
      targetItem.classList.toggle('active');
    });
  });
}

},{}],5:[function(require,module,exports){
"use strict";

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.onload = function () {
  var cookies = document.querySelector('#cookiesMessage');

  if (cookies) {
    var cookiesAccept = cookies.querySelectorAll('[data-toggle="cookies-accept"]');
    cookiesAccept.forEach(function (item) {
      item.addEventListener('click', function () {
        cookies.classList.add('hide');
        setTimeout(function () {
          cookies.remove();
        }, 1000);

        _jsCookie["default"].set('_ig_cookies_policy', 'accept', {
          expires: 365
        });
      });
    });
  }
};

},{"js-cookie":2}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formsToDef = void 0;

var _modal = require("./modal");

var _ctaGoals = require("../modules/cta-goals");

var forms = document.querySelectorAll('.form');

var onResponseFalse = function onResponseFalse(form, xhr, response) {
  var inputs = form.querySelectorAll('.input-control');
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector('.error-msg');
    var inputWrap = input.parentElement;

    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        inputWrap.classList.add('error');
        input.insertAdjacentHTML('afterend', '<span class="error-msg">' + response.errors[error].message + '</span>');
      }
    }
  });
};

var formsToDef = function formsToDef(modal) {
  var form = modal.querySelector('.form__body');
  var formResponse = modal.querySelector('.response-msg');

  if (form) {
    form.classList.remove('hidden');
    var inputs = form.querySelectorAll('.form-control');
    inputs.forEach(function (input) {
      input.parentElement.classList.remove('filled');
      input.value = '';
    });
  }

  if (formResponse) {
    formResponse.remove();
  }
};

exports.formsToDef = formsToDef;

if (forms.length) {
  forms.forEach(function (item) {
    var loader = item.querySelector('.loader');
    item.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target;
      var url = form.getAttribute('action');
      var data = new FormData(form);
      var fileInput = form.querySelector('input[type="file"]');

      if (fileInput) {
        for (var i = 0; i < fileInput.files.length; i++) {
          var file = fileInput.files[i];
          data.append('files[]', file);
        }
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(data);
      loader.style.display = 'block';

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          loader.style.display = '';
          var response = JSON.parse(xhr.responseText);

          if (response.status === 'error') {
            onResponseFalse(form, xhr, response);
          } else {
            var isModal = form.closest('.modal');
            var formBody = form.querySelector('.form__body');

            if (isModal) {
              formBody.insertAdjacentHTML('afterend', '<div class="response-msg">' + response["message"] + '</div>');
              formBody.classList.add('hidden');
            } else {
              document.querySelector('#modal--success .modal__content').insertAdjacentHTML('beforeend', '<div class="response-msg">' + response["message"] + '</div>');
              (0, _modal.openModal)('modal--success');
              var inputs = form.querySelectorAll('.form-control');
              inputs.forEach(function (input) {
                input.parentElement.classList.remove('filled');
                input.value = '';
              });
            }

            (0, _ctaGoals.reachGoals)(response.counters.goals.ym, response.counters.goals.ga, response.counters.goals.fb, response.counters.goals.gads);
          }
        }
      };
    });
  });
}

},{"../modules/cta-goals":27,"./modal":17}],7:[function(require,module,exports){
"use strict";

var _globalFunctions = require("./global-functions");

var foundationItems = document.querySelectorAll('.foundation__item');

if (foundationItems.length) {
  var windowWidth = document.body.offsetWidth;

  var detectTarget = function detectTarget(elem) {
    var target = elem;

    if (!target.classList.contains('foundation__item')) {
      target = target.closest('.foundation__item');
    }

    return target;
  };

  var foundationItemCalculate = function foundationItemCalculate(item) {
    var itemText = item.querySelector('.foundation__item-text-extra');
    var itemTextRect = itemText.getBoundingClientRect();
    var itemTextLeftOffset = +getComputedStyle(itemText).left.replace('px', '');
    var itemTextSize = itemTextRect['left'] + itemTextRect['width'] + itemTextLeftOffset;

    if (itemTextSize > windowWidth) {
      itemText.style.maxWidth = itemTextRect['width'] - itemTextLeftOffset + 'px';
    }
  };

  foundationItems.forEach(function (item) {
    foundationItemCalculate(item);

    if (!(0, _globalFunctions.isMobileDevice)()) {
      item.addEventListener('mouseover', function (e) {
        var hoveredItems = document.querySelectorAll('.foundation__item.hovered');
        var target = detectTarget(e.target);
        hoveredItems.forEach(function (it) {
          if (it !== target) {
            it.classList.remove('hovered');
            it.classList.remove('transition');
          }
        });
        setTimeout(function () {
          target.classList.add('hovered');
          target.classList.add('transition');
        }, 0);
      });
      item.addEventListener('mouseleave', function (e) {
        var target = e.target;
        target.classList.remove('hovered');
        setTimeout(function () {
          target.classList.remove('transition');
        }, 10);
      });
    }
  });
}

},{"./global-functions":9}],8:[function(require,module,exports){
"use strict";

var buttons = document.querySelectorAll('.glide__arrow');
var gliderElems = document.querySelectorAll('.glide:not(.glide--shadow)');
var gliders = [];
var slidersWithShadow = document.querySelectorAll('.glide--shadow');
gliderElems.forEach(function (element) {
  var perView = +element.getAttribute('data-glide-elems');
  var args;

  switch (perView) {
    case 3:
      args = {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        gap: '30px',
        hoverpause: false,
        breakpoints: {
          992: {
            perView: 2
          },
          768: {
            perView: 1
          }
        }
      };
      break;

    case 6:
      args = {
        type: 'carousel',
        startAt: 0,
        perView: 6,
        gap: '30px',
        hoverpause: false,
        breakpoints: {
          1600: {
            perView: 5
          },
          1400: {
            perView: 4
          },
          992: {
            perView: 3
          },
          768: {
            perView: 2
          },
          576: {
            perView: 1
          }
        }
      };
      break;

    default:
      args = {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        gap: '30px',
        dragThreshold: false,
        hoverpause: false,
        breakpoints: {
          1200: {
            dragThreshold: true
          }
        }
      };
  }

  if (element.hasAttribute('data-glider-autoplay')) {
    args.type = 'slider';
    args.autoplay = 7000;
    args.gap = 0;
  }

  var glide = new Glide('#' + element.id, args);
  gliders.push(glide);
  glide.mount();
});
slidersWithShadow.forEach(function (element) {
  var perView = +element.getAttribute('data-glide-elems');
  var section = element.closest('.section');
  section.style.overflow = 'hidden';
  var args = perView === 3 ? {
    type: 'carousel',
    startAt: 0,
    perView: 3,
    gap: '30px',
    dragThreshold: false,
    breakpoints: {
      1200: {
        perView: 2,
        dragThreshold: true
      },
      768: {
        perView: 1,
        dragThreshold: true
      }
    }
  } : {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    gap: '30px',
    dragThreshold: false,
    breakpoints: {
      1200: {
        dragThreshold: true
      }
    }
  };
  var glide = new Glide('#' + element.id, args);
  gliders.push(glide);
  glide.mount(); // class for disabled visible overflow on hover

  glide.on('run.before', function () {
    element.classList.add('running');
  });
  glide.on('run.after', function () {
    element.classList.remove('running');
  });
});
buttons.forEach(function (btn, index) {
  btn.index = index;
  btn.addEventListener('click', function (event) {
    var sliderIndex = Math.floor(btn.index / 2);

    if (gliders[sliderIndex]) {
      if (btn.classList.contains('glide__arrow--left')) {
        gliders[sliderIndex].go('<');
      } else {
        gliders[sliderIndex].go('>');
      }
    }
  });
});

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = void 0;

var isMobileDevice = function isMobileDevice() {
  return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
};

exports.isMobileDevice = isMobileDevice;

},{}],10:[function(require,module,exports){
"use strict";

var links = document.querySelectorAll('.glossary-link:not(.disabled)');
var allItems = document.querySelectorAll('.glossary-item');
var glossaryTags = document.querySelectorAll('.glossary-filter__tag');

var glossaryListener = function glossaryListener(e, links, allItems) {
  e.preventDefault();
  var category = e.target.getAttribute('data-letter');
  links.forEach(function (linkInner) {
    linkInner.classList.remove('active');

    if (linkInner.getAttribute('data-letter') === category) {
      linkInner.classList.add('active');
    }
  });

  if (category !== 'all') {
    allItems.forEach(function (item) {
      item.classList.add('inactive');
    });
    setTimeout(function () {
      document.querySelectorAll('.glossary-item[data-letter="' + category + '"]').forEach(function (catItem) {
        catItem.classList.remove('inactive');
      });
    }, 200);
  } else {
    allItems.forEach(function (catItem) {
      catItem.classList.remove('inactive');
    });
  }
};

if (links.length) {
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      glossaryListener(e, links, allItems);
    });
  });
}

var glossaryFiltering = function glossaryFiltering(e) {
  e.preventDefault();
  e.target.classList.toggle('active');
  var data = new FormData();
  var tags = '';
  glossaryTags.forEach(function (tag) {
    if (tag.classList.contains('active')) {
      tags += tag.getAttribute('data-tag') + ',';
    }
  });
  data.append('tags', tags);
  data.append('action', 'glossary_filter');
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/wp-admin/admin-ajax.php', true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE && xhr.status === 200) {
      if (xhr.responseText) {
        var response = JSON.parse(xhr.responseText);
        document.querySelector('.glossary-letters').innerHTML = response.head;
        document.querySelector('.glossary-body-outer').innerHTML = response.body;

        var _links = document.querySelectorAll('.glossary-link:not(.disabled)');

        _links.forEach(function (link) {
          link.addEventListener('click', function (e) {
            glossaryListener(e, _links, document.querySelectorAll('.glossary-item'));
          });
        });

        document.querySelectorAll('.glossary-filter__tag').forEach(function (tag) {
          tag.addEventListener('click', glossaryFiltering);
        });
      }
    }
  };
};

if (glossaryTags.length) {
  glossaryTags.forEach(function (tag) {
    tag.addEventListener('click', glossaryFiltering);
  });
}

var glossaryPopupLink = document.querySelectorAll('.glossary-popup-link');

if (glossaryPopupLink.length) {
  var glossaryPopupRemove = function glossaryPopupRemove(popup, link) {
    popup.remove();
    link.classList.remove('active');
  };

  glossaryPopupLink.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!link.classList.contains("active") && !link.querySelector('.glossary-popup')) {
        var excerpt = link.getAttribute('data-excerpt');
        var title = link.textContent;
        link.insertAdjacentHTML('beforeend', '<div class="glossary-popup card">' + '<div class="card__body">' + '<span>' + title + '</span> — ' + excerpt + '' + '</div>' + '</div>');
        var glossaryPopup = link.querySelector('.glossary-popup');

        if (glossaryPopup.offsetWidth + link.getBoundingClientRect().left > window.innerWidth) {
          glossaryPopup.classList.add('glossary-popup--right');
        } else {
          glossaryPopup.classList.remove('glossary-popup--right');
        } // removes active popups


        var activeLinks = document.querySelectorAll('.glossary-popup-link.active');
        activeLinks.forEach(function (activeLink) {
          if (activeLink !== link) {
            var popup = activeLink.querySelector('.glossary-popup');
            glossaryPopupRemove(popup, activeLink);
          }
        });
        link.classList.add('active');
        link.addEventListener('mouseleave', function () {
          glossaryPopupRemove(glossaryPopup, link);
        }, {
          once: true
        });
      }
    });
  });
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tabs = require("./tabs");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GreatSelect = /*#__PURE__*/function () {
  /**
   *
   * @param itemsSelector
   * @param options
   */
  function GreatSelect(itemsSelector, options) {
    _classCallCheck(this, GreatSelect);

    this.classes = {
      'main': 'great-select',
      'opened': 'open',
      'disabled': 'disabled',
      'list': 'list',
      'option': 'option',
      'current': 'current',
      'optionSelected': 'selected',
      'optionFocused': 'focus'
    };

    if (options && options.classes) {
      for (var optionClass in options.classes) {
        this.classes[optionClass] = options.classes[optionClass];
      }
    }

    this.selectItems = document.querySelectorAll(itemsSelector);
  }

  _createClass(GreatSelect, [{
    key: "init",
    value: function init() {
      var _this = this;

      //this._removeListeners();
      GreatSelect._iePointerEventsFix();

      this.selectItems.forEach(function (item) {
        item.style.display = 'none';
        var nextElement = item.nextElementSibling;

        if (!nextElement || nextElement && !nextElement.classList.contains(_this.classes.main)) {
          _this._createSelect(item);

          _this._addSelectListeners(item.nextElementSibling);
        }
      });

      this._addGlobalListeners();
    }
  }, {
    key: "_createSelect",
    value: function _createSelect(selectItem) {
      var _this2 = this;

      var selectDisabled = selectItem.getAttribute('disabled');
      var selectContainer = '<div class="' + this.classes.main + ' great-select ' + (selectItem.getAttribute('class') || '') + (selectDisabled ? this.classes.disabled : '') + '" ' + '' + (!selectDisabled ? 'tabindex="0"' : '') + '>' + '<span class="' + this.classes.current + '"></span>' + '<ul class="' + this.classes.list + '"></ul>' + '</div>';
      selectItem.insertAdjacentHTML('afterend', selectContainer);
      var dropdown = selectItem.nextElementSibling;
      var options = selectItem.querySelectorAll('option');
      var selectedOption = selectItem.querySelector('option:checked');
      var optionsContainer = dropdown.querySelector('ul');
      dropdown.querySelector('.' + this.classes.current).innerHTML = selectedOption.getAttribute('data-display') || selectedOption.textContent;
      options.forEach(function (option) {
        var displayText = option.getAttribute('data-display');
        var optionItem = '<li data-value="' + option.value + '" ' + 'data-display="' + (displayText || '') + '" ' + 'class="' + _this2.classes.option + (option.selected ? ' ' + _this2.classes.optionSelected + ' ' : ' ') + (option.getAttribute('class') + ' ' || ' ') + (option.disabled ? ' ' + _this2.classes.disabled : '') + '">' + option.textContent + '</li>';
        optionsContainer.insertAdjacentHTML('beforeend', optionItem);
      });
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      var allSelects = document.querySelectorAll('.' + this.classes.main);
      allSelects.forEach(function (select) {
        var clone = select.cloneNode(true);
        select.parentNode.replaceChild(clone, select);
      });
    }
  }, {
    key: "_addSelectListeners",
    value: function _addSelectListeners(gSelectItem) {
      var _this3 = this;

      gSelectItem.addEventListener('click', function (e) {
        var dropdown = e.target.closest('.' + _this3.classes.main);
        document.querySelectorAll('.' + _this3.classes.main).forEach(function (item) {
          if (item !== dropdown) {
            item.classList.remove(_this3.classes.opened);
          }
        });
        dropdown.classList.toggle(_this3.classes.opened);

        if (dropdown.classList.contains(_this3.classes.opened)) {
          var focusedOption = dropdown.querySelector('.' + _this3.classes.optionFocused);

          if (focusedOption) {
            focusedOption.classList.remove(_this3.classes.optionFocused);
          }

          dropdown.querySelector('.' + _this3.classes.optionSelected).classList.add(_this3.classes.optionFocused);
        } else {
          dropdown.focus();
        }
      });
      var activeOptions = gSelectItem.querySelectorAll('.' + this.classes.option + ':not(.' + this.classes.disabled + ')');
      activeOptions.forEach(function (option) {
        option.addEventListener('click', function (e) {
          var targetOption = e.target;
          gSelectItem.querySelector('.' + _this3.classes.optionSelected).classList.remove(_this3.classes.optionSelected);
          targetOption.classList.add(_this3.classes.optionSelected);
          gSelectItem.querySelector('.' + _this3.classes.current).textContent = targetOption.getAttribute('data-display') || targetOption.textContent;
          gSelectItem.previousElementSibling.value = targetOption.getAttribute('data-value');
          gSelectItem.previousElementSibling.dispatchEvent(new Event('change'));
          (0, _tabs.tabsWorker)(option); //$dropdown.prev('select').val($option.data('value')).trigger('change');
        });
      });
      gSelectItem.addEventListener('keydown', function (e) {
        var targetDropdown = e.target.closest('.' + _this3.classes.main);
        var focusedOption = targetDropdown.querySelector('.' + _this3.classes.optionFocused) || targetDropdown.querySelector('.' + _this3.classes.option + '.' + _this3.classes.optionSelected);

        if (e.code === 'Space' || e.code === 'Enter') {
          e.preventDefault();

          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            focusedOption.click();
          } else {
            targetDropdown.click();
          }
        } else if (e.code === 'ArrowDown') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find next not disabled
            //var $next = $focused_option.nextAll('.option:not(.disabled)').first();
            // let nextAll = false;
            // nextAll = [].filter.call(focusedOption.parentNode.children,  elem => {
            //     return (elem.previousElementSibling === focusedOption) ? nextAll = true : nextAll;
            // });
            var next = focusedOption.nextElementSibling;

            if (next) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              next.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'ArrowUp') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find prev not disabled
            var prev = focusedOption.previousElementSibling;

            if (prev) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              prev.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'Escape') {
          targetDropdown.classList.remove(_this3.classes.opened);
        } else if (e.code === 'Tab') {
          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            e.preventDefault();
          }
        }
      });
    }
  }, {
    key: "_addGlobalListeners",
    value: function _addGlobalListeners() {
      var _this4 = this;

      document.addEventListener('click', function (e) {
        var openedSelect = document.querySelector('.' + _this4.classes.main + '.' + _this4.classes.opened);

        if (openedSelect && !openedSelect.contains(e.target)) {
          openedSelect.classList.remove(_this4.classes.opened);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this5 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;
        var opened = dropdown.classList.contains(_this5.classes.opened);

        if (dropdown && dropdown.classList.contains(_this5.classes.main)) {
          dropdown.remove();

          _this5._createSelect(select);

          if (opened) {
            select.nextElementSibling.click();
          }
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;

        if (dropdown && dropdown.classList.contains(_this6.classes.main)) {
          dropdown.remove();
          select.style.display = '';
        } // if ($('.nice-select').length == 0) {
        //     $(document).off('.nice_select');
        // }

      });
    }
  }], [{
    key: "_iePointerEventsFix",
    value: function _iePointerEventsFix() {
      // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
      var style = document.createElement('a').style;
      style.cssText = 'pointer-events:auto';

      if (style.pointerEvents !== 'auto') {
        document.querySelector('html').classList.add('no-csspointerevents');
      }
    }
  }]);

  return GreatSelect;
}();

var _default = GreatSelect;
exports["default"] = _default;

},{"./tabs":25}],12:[function(require,module,exports){
"use strict";

var _greatSelect = _interopRequireDefault(require("./great-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var inputs = document.querySelectorAll('.input-wrapper input, .input-wrapper textarea');

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.add('focused');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.remove('focused');

  if (input.value !== '') {
    inputControl.classList.add('filled');
    inputControl.classList.remove('error');
  } else {
    inputControl.classList.remove('filled');
  }
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    item.addEventListener('focus', inputFocus);
    item.addEventListener('blur', inputBlur);
    item.addEventListener('input', inputTyping);
  });
}

var fileInputs = document.querySelectorAll('input[type="file"]');

if (fileInputs.length) {
  fileInputs.forEach(function (input) {
    var fileWrap = input.parentElement;

    if (!fileWrap.classList.contains('input-file-wrap')) {
      fileWrap = fileWrap.parentElement;
    }

    input.addEventListener('change', function (e) {
      var that = e.target;
      var files = that.files;
      var filesStr = '';
      Array.from(files).forEach(function (file, index) {
        if (index) {
          filesStr += ', ';
        }

        filesStr += file.name;
      });
      fileWrap.querySelector('.input-file-wrap__list').textContent = filesStr;
      var fileHolder = fileWrap.querySelector('.input-file-wrap__holder');

      if (input.value) {
        fileHolder.classList.add('visible');
      } else {
        fileHolder.classList.remove('visible');
      }
    });
    var rmBtn = fileWrap.querySelector('.input-file-wrap__rm-btn');

    if (rmBtn) {
      rmBtn.addEventListener('click', function (e) {
        input.value = '';
        var that = e.target;
        that.parentElement.classList.remove('visible');
      });
    }
  });
}

var checkboxes = document.querySelectorAll('.checkbox-wrap input');

if (checkboxes.length) {
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function (e) {
      e.target.parentElement.classList.toggle('checked');
    });
  });
}

var selectItem = document.querySelector('select');

if (selectItem) {
  new _greatSelect["default"]('select', {
    classes: {
      'main': 'select',
      'list': 'select__list',
      'current': 'select__current',
      'optionSelected': 'active',
      'option': 'opt'
    }
  }).init();
}

},{"./great-select":11}],13:[function(require,module,exports){
"use strict";

var _bodyScrollLock = require("body-scroll-lock");

var _globalFunctions = require("./global-functions");

var body = document.querySelector('body');
var header = document.querySelector('.header');
var headerBtns = document.querySelector('.header__buttons');
var lightboxElems = document.querySelectorAll('[data-toggle="lightbox"]');
var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
lightboxElems.forEach(function (parent) {
  var lightbox;
  var img = parent.querySelector('img');

  var createImgItem = function createImgItem(imageSrc) {
    var imageWrapper = document.createElement('div');
    imageWrapper.classList.add('lightbox-item');
    var image = document.createElement('img');
    image.setAttribute('src', imageSrc);
    imageWrapper.append(image);
    return imageWrapper;
  };

  var showLightbox = function showLightbox(e) {
    var img = e.target;
    var lightboxImage = document.createElement('div');
    lightboxImage.classList.add('lightbox-items');
    var imageSrc = img.getAttribute('src');
    lightboxImage.append(createImgItem(imageSrc));
    var closeSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18.121" height="18.121" viewBox="0 0 18.121 18.121">\n' + '    <g transform="translate(1.061 1.061)">\n' + '        <line data-name="Line 4" x2="16" y2="16" fill="none" stroke="#abc0e1" stroke-miterlimit="10" stroke-width="3"></line>\n' + '        <line data-name="Line 5" y1="16" x2="16" fill="none" stroke="#abc0e1" stroke-miterlimit="10" stroke-width="3"></line>\n' + '    </g>\n' + '</svg>';
    var lightboxLayout = '<div id="lightbox" class="lightbox">' + "<button class=\"lightbox__close\">".concat(closeSvg, "</button>") + '<div class="lightbox__wrapper">' + '<div class="lightbox__content">' + '</div>' + '</div>' + '</div>';
    document.body.insertAdjacentHTML('afterend', lightboxLayout);
    var lightbox = document.querySelector('.lightbox');
    setTimeout(function () {
      if (!(0, _globalFunctions.isMobileDevice)()) {
        header.style.paddingRight = scrollbarWidth + 'px';
        body.style.paddingRight = scrollbarWidth + 'px';

        if (window.innerWidth >= 1200) {
          headerBtns.style.paddingRight = scrollbarWidth + 'px';
        }
      }

      (0, _bodyScrollLock.disableBodyScroll)(lightbox);
      lightbox.classList.add('show');
    }, 0);
    var lightboxContent = lightbox.querySelector('.lightbox__content');
    lightboxContent.textContent = '';
    lightboxContent.append(lightboxImage);
    var currentImg = lightbox.querySelector('.lightbox-item>img');
    lightbox.addEventListener('click', function (e) {
      if (currentImg !== e.target) {
        closeLightbox(lightbox);
      }
    });
    var closeBtn = lightbox.querySelector('.lightbox__close');
    closeBtn.addEventListener('click', function () {
      closeLightbox(lightbox);
    });
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeLightbox(lightbox);
      }
    });
  };

  var closeLightbox = function closeLightbox(lightbox) {
    if (lightbox) {
      lightbox.classList.add('hiding');
    }

    setTimeout(function () {
      header.style.paddingRight = '';
      body.style.paddingRight = '';
      headerBtns.style.paddingRight = '';
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }, 100);
    setTimeout(function () {
      if (lightbox) {
        lightbox.remove();
        lightbox = null;
      }
    }, 200);
  };

  var addLightboxHanler = function addLightboxHanler() {
    if (window.innerWidth >= 768) {
      img.addEventListener('click', showLightbox);
    } else {
      img.removeEventListener('click', showLightbox);
    }
  };

  addLightboxHanler();
  window.addEventListener('resize', addLightboxHanler);
});

},{"./global-functions":9,"body-scroll-lock":1}],14:[function(require,module,exports){
"use strict";

var _tagsFilter = _interopRequireDefault(require("./tags-filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadMoreBtn = document.querySelector('.load-more-btn');
var loadMoreContainer = document.querySelector('.load-more-cont');

if (loadMoreBtn) {
  var currentOffset = loadMoreBtn.getAttribute('data-offset');
  var postType = loadMoreBtn.getAttribute('data-type');

  var defaultLoadMore = function defaultLoadMore() {
    var data = new FormData();
    data.append('action', 'load_more');
    data.append('offset', currentOffset);
    data.append('post_type', postType);
    data.append('tags', (0, _tagsFilter["default"])());
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/wp-admin/admin-ajax.php', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(data);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.DONE && xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);

        if (response['cards']) {
          loadMoreContainer.insertAdjacentHTML('beforeend', response['cards']);
        } else {
          loadMoreBtn.style.display = 'none';
        }

        if (response['morePosts']) {
          currentOffset = response['currentOffset'];
          loadMoreBtn.addEventListener('click', loadMore);
        } else {
          loadMoreBtn.style.display = 'none';
        }
      }
    };
  };

  var simpleLoadMore = function simpleLoadMore(loadMoreBtn) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', loadMoreBtn.href, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.responseType = "document";
    xhr.send();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.DONE && xhr.status === 200) {
        var response = xhr.response;
        var responseCards = response.querySelector('.load-more-cont').innerHTML;
        var responseBtn = response.querySelector('.load-more-btn');
        loadMoreContainer.innerHTML += responseCards;

        if (responseBtn) {
          loadMoreBtn.href = responseBtn.href;
        } else {
          loadMoreBtn.style.display = 'none';
        }
      }
    };
  };

  var loadMore = function loadMore(e) {
    e.preventDefault();

    if (loadMoreBtn.classList.contains('load-more-btn--simple')) {
      simpleLoadMore(loadMoreBtn);
    } else {
      defaultLoadMore();
    }
  };

  loadMoreBtn.addEventListener('click', loadMore);
}

},{"./tags-filter":26}],15:[function(require,module,exports){
"use strict";

var dropdown = document.querySelectorAll('.main-nav__dropdown');
var header = document.querySelector('.header');
var sectionToggler = document.querySelectorAll('[data-toggle="dropdown-section"]');
dropdown.forEach(function (item) {
  item.addEventListener('mouseenter', function (e) {
    item.querySelector('.main-nav__dropdown-toggle').classList.add('active');
    item.querySelector('.main-nav__dropdown-menu').classList.add('show');

    if (!item.querySelector('.submenu').classList.contains('submenu--wide')) {
      item.style.position = 'relative';
    }

    header.classList.add('header--opened');
  });
  item.addEventListener('mouseleave', function (e) {
    item.querySelector('.main-nav__dropdown-toggle').classList.remove('active');
    item.querySelector('.main-nav__dropdown-menu').classList.remove('show');
    header.classList.remove('header--opened');
  });
});
sectionToggler.forEach(function (item) {
  item.addEventListener('mouseover', function () {
    var target = document.getElementById(item.dataset.target);
    sectionToggler.forEach(function (sibling) {
      var siblingTarget = document.getElementById(sibling.dataset.target);
      sibling.classList.remove('active');
      siblingTarget.classList.remove('show');
    });
    item.classList.add('active');
    target.classList.add('show');
  });
});

},{}],16:[function(require,module,exports){
"use strict";

var _bodyScrollLock = require("body-scroll-lock");

var body = document.body;
var menu = document.getElementById('mobile-menu');

if (menu) {
  var changeSection = function changeSection(target) {
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    mobileMenuSections.forEach(function (section) {
      return section.classList.remove('active');
    });

    if (target) {
      target.classList.add('active');
      mobileMenuBody.classList.add('expanded');
      (0, _bodyScrollLock.disableBodyScroll)(target, {
        reserveScrollBarGap: true
      });
    } else {
      mobileMenuBody.classList.remove('expanded');
      (0, _bodyScrollLock.disableBodyScroll)(mobileMenuBody, {
        reserveScrollBarGap: true
      });
    }
  };

  var menuOpen = document.getElementById('mobile-open');
  var menuClose = document.getElementById('mobile-close');
  var mobileMenuBody = document.getElementById('mobile-menu-body');
  var expandTogglers = document.querySelectorAll('.has-items');
  var mobileMenuWrapper = document.querySelector('.mobile-wrapper');
  var mobileMenuSections = mobileMenuWrapper.querySelectorAll('.mobile-menu__section');

  var resetMobileMenu = function resetMobileMenu(e) {
    var sectionsTogglers = document.querySelectorAll('.mobile-menu__link.active');
    var sections = document.querySelectorAll('.mobile-menu__section.show');
    sectionsTogglers.forEach(function (item) {
      item.classList.remove('active');
    });
    sections.forEach(function (item) {
      item.classList.remove('show', 'active');
    });
    mobileMenuBody.classList.remove('expanded');
    menuOpen.classList.remove('active');
  };

  var closeMenu = function closeMenu() {
    body.classList.add('hiding');
    menu.classList.add('hiding');
    setTimeout(function () {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      menu.classList.remove('show');
      menu.classList.remove('hiding');
      body.classList.remove('modal-open');
      body.classList.remove('hiding');
    }, 100);
    resetMobileMenu();
  };

  var openMenu = function openMenu(e) {
    body.classList.add('modal-open');
    menu.classList.add('show');
    setTimeout(function () {
      (0, _bodyScrollLock.disableBodyScroll)(mobileMenuBody, {
        reserveScrollBarGap: true
      });
    }, 0);
  };

  menuOpen.addEventListener('click', function () {
    if (window.innerWidth > 767) {
      menuOpen.classList.toggle('active');
    }

    !menu.classList.contains('show') ? openMenu() : closeMenu();
  });
  menuClose.addEventListener('click', function () {
    closeMenu();
  });
  expandTogglers.forEach(function (item) {
    var closeSection = document.querySelectorAll('.has-section');

    var expandAction = function expandAction(e) {
      e.preventDefault();
      var targetItem = item.nextElementSibling;
      item.classList.toggle('active');
      targetItem.classList.toggle('show');
      changeSection(targetItem);
    };

    item.addEventListener('click', expandAction);
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        expandAction();
      }
    });
    closeSection.forEach(function (close) {
      close.addEventListener('click', function (e) {
        e.preventDefault();
        close.closest('.mobile-menu__section').classList.remove('show');
        changeSection(mobileMenuWrapper.querySelector("[data-target-item=\"".concat(close.dataset.section, "\"]")));
      });
    });
  });

  var closeMobileByOuterClick = function closeMobileByOuterClick(e) {
    var menuShow = document.querySelector('.mobile-wrapper.show');
    var search = document.querySelector('.search');

    if (menuShow && !menuShow.contains(e.target) && !menuOpen.contains(e.target) && !search.contains(e.target)) {
      closeMenu();
      resetMobileMenu();
    }
  };

  window.addEventListener('click', closeMobileByOuterClick);
}

},{"body-scroll-lock":1}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = void 0;

var _globalFunctions = require("./global-functions");

var _bodyScrollLock = require("body-scroll-lock");

var _form = require("./form");

var btns = document.querySelectorAll('[data-toggle="modal"]');
var closeBtns = document.querySelectorAll('.modal__close');
var body = document.querySelector('body');
var header = document.querySelector('.header');
var headerBtns = document.querySelector('.header__buttons');
var root = document.getElementsByTagName('html')[0];

var closePopupByOuterClick = function closePopupByOuterClick(e) {
  var popup = document.querySelector('.modal.visible').querySelector('.modal__content');

  if (popup && !popup.contains(e.target) && !(e.target.getAttribute('data-toggle') === 'modal')) {
    closeModal();
  }
};

var openModal = function openModal(sel) {
  var modal = document.getElementById(sel);
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  setTimeout(function () {
    if (!(0, _globalFunctions.isMobileDevice)()) {
      header.style.paddingRight = scrollbarWidth + 'px';
      body.style.paddingRight = scrollbarWidth + 'px';
      headerBtns.style.paddingRight = scrollbarWidth + 'px';
    }

    (0, _bodyScrollLock.disableBodyScroll)(modal);
    modal.classList.add('visible');
  }, 0);
  setTimeout(function () {
    document.addEventListener('click', closePopupByOuterClick);
  }, 200);
};

exports.openModal = openModal;

var closeModal = function closeModal() {
  var modal = document.querySelector('.modal.visible');
  modal.classList.add('closing');
  setTimeout(function () {
    modal.classList.remove('visible');
    root.classList.remove('modal-open');
    header.style.paddingRight = '';
    body.style.paddingRight = '';
    headerBtns.style.paddingRight = '';
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
  }, 100);
  setTimeout(function () {
    modal.classList.remove('closing');
    (0, _form.formsToDef)(modal);
  }, 300);
  document.removeEventListener('click', closePopupByOuterClick);
};

exports.closeModal = closeModal;

if (btns.length) {
  btns.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var target = item.getAttribute('data-target').replace('#', '');
      openModal(target);
    });
  });
}

if (closeBtns.length) {
  closeBtns.forEach(function (item) {
    item.addEventListener('click', closeModal);
  });
}

document.addEventListener('keydown', function (event) {
  var key = event.key;
  var modal = document.querySelector('.modal.visible');

  if (modal && key === "Escape") {
    closeModal();
  }
});

},{"./form":6,"./global-functions":9,"body-scroll-lock":1}],18:[function(require,module,exports){
"use strict";

var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

if (viewportWidth > 992) {
  var serviceScene = document.querySelectorAll('.parallax svg');
  serviceScene.forEach(function (scene) {
    return new Parallax(scene);
  });
}

},{}],19:[function(require,module,exports){
"use strict";

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

;

(function () {
  // helpers
  var regExp = function regExp(name) {
    return new RegExp('(^| )' + name + '( |$)');
  };

  var forEach = function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
      fn.call(scope, list[i]);
    }
  }; // class list object with basic methods


  function ClassList(element) {
    this.element = element;
  }

  ClassList.prototype = {
    add: function add() {
      forEach(arguments, function (name) {
        if (!this.contains(name)) {
          this.element.className += ' ' + name;
        }
      }, this);
    },
    remove: function remove() {
      forEach(arguments, function (name) {
        this.element.className = this.element.className.replace(regExp(name), '');
      }, this);
    },
    toggle: function toggle(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function contains(name) {
      return regExp(name).test(this.element.className);
    },
    // bonus..
    replace: function replace(oldName, newName) {
      this.remove(oldName), this.add(newName);
    }
  }; // IE8/9, Safari

  if (!('classList' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'classList', {
      get: function get() {
        return new ClassList(this);
      }
    });
  } // replace() support for others


  if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
  }
})();

},{}],20:[function(require,module,exports){
"use strict";

var btns = document.querySelectorAll('.scrollToBlock');
btns.forEach(function (btn) {
  var OFFSET = 200;
  btn.addEventListener('click', function (evt) {
    evt.preventDefault();
    var targetBlock = document.getElementById('scroll');

    if (targetBlock) {
      var top = window.scrollY + targetBlock.getBoundingClientRect().bottom + OFFSET;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  });
});

},{}],21:[function(require,module,exports){
"use strict";

var _scrollTo = _interopRequireDefault(require("../modules/scrollTo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var body = document.body;
var scrollTopOffset = 50;
var asideLinks = document.querySelectorAll('.aside-menu__link');
window.addEventListener('scroll', function () {
  if (window.scrollY >= scrollTopOffset) {
    body.classList.add('scrolled');
  } else {
    body.classList.remove('scrolled');
  }
});
asideLinks.forEach(function (link) {
  link.addEventListener('click', function (e) {
    var target = link.getAttribute('href');
    document.querySelector('.aside-menu__link.active').classList.remove('active');
    link.classList.add('active');
    (0, _scrollTo["default"])(target, 1000);
    e.preventDefault();
  });
});

},{"../modules/scrollTo":28}],22:[function(require,module,exports){
"use strict";

var targets = document.querySelectorAll('*[id^="rt-"]') || [];
var sections = {};
var i = 0;
targets.forEach(function (target) {
  return !sections[target.id] ? sections[target.id] = target.getBoundingClientRect().top + window.scrollY - document.querySelector('.header').getBoundingClientRect().height - 100 : '';
});

if (document.querySelector('.anchor-spy')) {
  window.onscroll = function () {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

    for (i in sections) {
      if (sections[i] <= scrollPosition) {
        document.querySelector('.anchor-spy.active').classList.remove('active');
        document.querySelector('a[href*=' + i + ']').classList.add('active');
      }
    }
  };
}

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeSearchField = void 0;
var searchForm = document.querySelectorAll('.search-form') || [];
searchForm.forEach(function (form) {
  var searchToggler = form.querySelector('.search__toggler');
  var searchClose = form.querySelector('.search__close');
  var input = form.querySelector('input');
  searchToggler.addEventListener('click', function () {
    input.classList.toggle('show');
    form.classList.toggle('active');

    if (input.classList.contains('show')) {
      input.focus();
    }

    if (input.value) {
      form.submit();
      input.value = '';
    }
  });
  searchClose.addEventListener('click', function () {
    closeSearchField(form);
  });
});

var closeSearchField = function closeSearchField(form) {
  var input = form.querySelector('input');
  input.classList.remove('show');
  form.classList.remove('active');
};

exports.closeSearchField = closeSearchField;

},{}],24:[function(require,module,exports){
"use strict";

var _globalFunctions = require("./global-functions");

if ((0, _globalFunctions.isMobileDevice)()) {
  document.querySelector('body').classList.add('touch-device');
}

},{"./global-functions":9}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsWorker = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var tabsLinks = document.querySelectorAll('.tabs__nav-link');
var tabGroups = document.querySelectorAll('.tabs');
var btnArrow = document.querySelectorAll('.tabs__arrow');
var btnControl = document.querySelectorAll('.tabs__control');

var tabsWorker = function tabsWorker(item) {
  var tabGroup = item.closest('.tabs');
  var allTabs = tabGroup.querySelectorAll('.tabs__pane');
  var allLinks = tabGroup.querySelectorAll('.tabs__nav-link');
  var showAll = (item.getAttribute('data-tab') || item.getAttribute('data-value')) === 'all';
  var targetTab = item.getAttribute('data-tab');

  if (!targetTab) {
    targetTab = item.getAttribute('data-value');
  }

  var allTabsContent = document.querySelectorAll('[data-tab-content]');
  var allTabsTarget = document.querySelectorAll('[data-tab-content="' + targetTab + '"]');

  if (allTabs.length) {
    allTabs.forEach(function (item) {
      item.classList.remove('active');
    });
  }

  allTabsContent.forEach(function (item) {
    item.classList.remove('active');
  });
  allTabsTarget.forEach(function (item) {
    item.classList.add('active');
  });

  if (allLinks.length) {
    allLinks.forEach(function (item) {
      item.classList.remove('active');
    });
  }

  if (showAll) {
    allTabsContent.forEach(function (item) {
      item.classList.add('active');
    });
  }

  item.classList.add('active');
};

exports.tabsWorker = tabsWorker;

var changeTab = function changeTab(panes, links, direction) {
  direction = direction ? direction : 'next';

  var activeTabIndex = _toConsumableArray(panes).findIndex(function (item) {
    return item.classList.contains('active');
  });

  var nextTabIndex = direction === 'prev' ? (activeTabIndex + panes.length - 1) % panes.length : (activeTabIndex + 1) % panes.length;
  var nextTab = panes[nextTabIndex];

  if (nextTab) {
    if (links.length) {
      links[activeTabIndex].classList.remove('active');
      links[nextTabIndex].classList.add('active');
    }

    panes[activeTabIndex].classList.remove('active');
    panes[activeTabIndex].style.transform = '';
    panes[nextTabIndex].classList.add('active');
  }
};

var tabGroupsHeight = function tabGroupsHeight(groupContent, panes) {
  if (groupContent && panes.length) {
    if (window.innerWidth > 992) {
      var minHeight = 0;
      panes.forEach(function (tab) {
        var lastElement = tab.lastElementChild;
        var lastMargin = +getComputedStyle(lastElement).marginBottom.replace('px', '');
        minHeight = Math.max(minHeight, tab.offsetHeight + lastMargin);
      });
      groupContent.style.minHeight = minHeight + 'px';
    } else {
      var height = 0;
      panes.forEach(function (tab) {
        height = Math.max(height, tab.offsetHeight);
      });
      panes.forEach(function (tab) {
        tab.style.minHeight = height + 'px';
      });
      groupContent.style.minHeight = height + 'px';
    }
  }
};

if (tabGroups.length) {
  var isEventsListenerActive = false;
  tabGroups.forEach(function (group) {
    var panes = group.querySelectorAll('.tabs__pane');
    var links = group.querySelectorAll('.tabs__nav-link');

    if (panes.length) {
      panes[0].classList.add('active');

      if (links.length) {
        links[0].classList.add('active');
      }
    }

    var groupContent = group.querySelector('.tabs__content');

    if (groupContent) {
      tabGroupsHeight(groupContent, panes);
    }

    var eventsHandlersControls = function eventsHandlersControls() {
      if (window.innerWidth < 992 && !isEventsListenerActive && groupContent) {
        var handlePan = function handlePan(e) {
          var item = e.target.closest('.tabs__pane');

          switch (e.type) {
            case 'panleft':
            case 'panright':
              if (Math.abs(e.deltaX) > 25 && Math.abs(e.deltaY) < 50) {
                item.style.transform = "translateX(".concat(e.deltaX + 'px', ")");
              }

              break;

            case 'panend':
            case 'pancancel':
              if (Math.abs(e.deltaX) > 25 && Math.abs(e.deltaY) < 50) {
                if (e.deltaX > 0) {
                  changeTab(panes, links, 'prev');
                } else {
                  changeTab(panes, links);
                }
              }

              item.style.transform = '';
              break;
          }
        };

        var handleHammer = function handleHammer(e) {
          switch (e.type) {
            case 'panleft':
            case 'panright':
            case 'panend':
            case 'pancancel':
              handlePan(e);
              break;
          }
        };

        var tabsGroupsEvents = new Hammer(groupContent);
        tabsGroupsEvents.on('swipeleft swiperight panleft panright panend pancancel', handleHammer);

        if (btnArrow) {
          btnArrow.forEach(function (arrow) {
            arrow.addEventListener('click', function (e) {
              e.preventDefault();
              var direction = arrow.getAttribute('data-tab-arrow');
              changeTab(panes, links, direction);
            });
          });
        }
      }

      isEventsListenerActive = true;
    };

    eventsHandlersControls();
    btnControl.forEach(function (control) {
      control.addEventListener('click', function (e) {
        e.preventDefault();
        var direction = control.getAttribute('data-tab-arrow');
        changeTab(panes, links, direction);
      });
    });
    window.addEventListener('resize', function () {
      setTimeout(function () {
        tabGroupsHeight(groupContent, panes);
        eventsHandlersControls();
      }, 200);
    });
  });
  tabsLinks.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      tabsWorker(item);
    });
  });
}

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var tagBtns = document.querySelectorAll('.tag-btn');
var currentTags = '';

if (tagBtns.length) {
  var loadMoreContainer = document.querySelector('.load-more-cont');
  var loadMoreBtn = document.querySelector('.load-more-btn');
  var postType = document.querySelector('.tags').getAttribute('data-type');

  var filterPosts = function filterPosts(e) {
    e.target.classList.toggle('active');
    var data = new FormData();
    currentTags = '';
    tagBtns.forEach(function (tag, index) {
      if (tag.classList.contains('active')) {
        currentTags += tag.getAttribute('data-tag') + ',';
      }
    });
    data.append('tags', currentTags);
    data.append('post_type', postType);
    data.append('action', 'tags_filter');
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/wp-admin/admin-ajax.php', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(data);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.DONE && xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);

        if (response['cards']) {
          loadMoreContainer.innerHTML = response['cards'];
        } else {
          loadMoreContainer.innerHTML = response['responseText'];
        }

        if (loadMoreBtn) {
          if (response['morePosts']) {
            loadMoreBtn.style.display = '';
          } else {
            loadMoreBtn.style.display = 'none';
          }
        }
      }
    };
  };

  tagBtns.forEach(function (tag) {
    tag.addEventListener('click', filterPosts);
  });
}

var getCurrentTags = function getCurrentTags() {
  return currentTags;
};

var _default = getCurrentTags;
exports["default"] = _default;

},{}],27:[function(require,module,exports){
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @param {String} ymGoal
 * @param {Object} gaGoal
 * @param {String} fbGoal
 * @param {String} gadsGoal
 */
module.exports.reachGoals = function (ymGoal, gaGoal, fbGoal, gadsGoal) {
  var ymCounterTag = document.querySelector('[name="yandex-counter"]');
  var ymCounterNumber = ymCounterTag ? ymCounterTag.getAttribute('content') : '';
  var ym = 'yaCounter' + ymCounterNumber;
  var gadsIdTag = document.getElementById('google-ads-id');
  var gadsId = gadsIdTag ? gadsIdTag.getAttribute('content') : '';
  var gaGoalIsSet = typeof gaGoal.label !== 'undefined' && typeof gaGoal.action !== 'undefined' && typeof gaGoal.category !== 'undefined';

  var findCounter = function findCounter(i) {
    if (window[ym] === undefined) {
      i--;
      setTimeout(function () {
        return findCounter(i);
      }, 300);
    } else if (typeof ymCounterNumber !== 'undefined' && ymCounterNumber.length && typeof ymGoal !== 'undefined') {
      window[ym].reachGoal(ymGoal);

      if (gaGoalIsSet) {
        window.yaParams = _defineProperty({}, gaGoal.category, _defineProperty({}, gaGoal.action, _defineProperty({}, gaGoal.label, [window.location.href.split('?')[0]])));
        window[ym].params(window.yaParams || {});
      }
    }
  };

  findCounter(10);

  if (typeof ga !== 'undefined' && gaGoalIsSet) {
    ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
  }

  if (typeof gtag !== 'undefined' && typeof gadsGoal !== 'undefined' && gadsGoal.length && gadsId !== '') {
    gtag('event', 'conversion', {
      'send_to': gadsId + '/' + gadsGoal
    });
  }

  if (typeof fbq !== 'undefined' && fbGoal) {
    fbq('track', fbGoal);
  }
};

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDomElement = isDomElement;
exports["default"] = scrollTo;

/**
 * @param {Element} element
 *
 * @return {Boolean}
 */
function isDomElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}

function scrollTo(element, duration) {
  if (element && (isDomElement(element) || document.querySelector(element))) {
    var OFFSET = 50;
    var target = isDomElement(element) ? element : document.querySelector(element);
    var startingY = window.pageYOffset;
    var elementY = window.pageYOffset + target.getBoundingClientRect().top;
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY - document.querySelector('.header').getBoundingClientRect().height - OFFSET;
    var diff = targetY - startingY; // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294

    var easing = function easing(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    var start;

    if (diff) {
      // Bootstrap our animation - it will get called right before next frame shall be rendered.
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) {
          start = timestamp;
        }

        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);

        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  }
}

},{}]},{},[3]);
